// extracted by mini-css-extract-plugin
export default {"result":"AskTheOracle_result__X7UbT","buttons":"AskTheOracle_buttons__7RDhG"};